export default __webpack_public_path__ + "static/media/case-V60.4e88d865.jpg";